import { Label, Switch, cn } from '@design-system';
import { Sparkles } from 'lucide-react';

import { useAnimationPreferences } from '@/features/client-onboarding';

interface AnimationToggleProps {
  className?: string;
}

export function AnimationToggle({ className }: AnimationToggleProps) {
  const { animationsEnabled, toggleAnimations } = useAnimationPreferences();

  return (
    <div
      className={cn(
        'bg-muted flex items-center gap-2 rounded-full border px-2.5 py-2 transition-colors',
        { 'bg-primary/5 border-primary/10': animationsEnabled },
        className,
      )}
    >
      <Sparkles
        className={cn('text-muted-foreground ml-1 size-4 transition-colors', {
          'text-primary': animationsEnabled,
        })}
      />
      <Label
        htmlFor="animation-toggle"
        className={cn('text-foreground cursor-pointer text-sm font-medium transition-colors', {
          'text-primary': animationsEnabled,
        })}
      >
        Animations
      </Label>
      <Switch
        id="animation-toggle"
        checked={animationsEnabled}
        onCheckedChange={toggleAnimations}
      />
    </div>
  );
}
